import { render, staticRenderFns } from "./ModulesConfig.vue?vue&type=template&id=193098a0"
import script from "./ModulesConfig.vue?vue&type=script&lang=js"
export * from "./ModulesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports